<div class="inbox-center-content" [ngClass]="{ 'component-loading': loading }">
  <div *ngIf="thread != null" class="header-wrapper">
    <div class="header">
      <div class="subject">
        <div class="thread-title" title="{{ thread?.subject }}">
          {{ thread?.subject }}
        </div>
        <span dropdown [autoClose]="true" container="body" [insideClick]="true">
          <span
            id="dLabel"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="dropdown-icon"
            dropdownToggle
          >
            <a class="link-to-workspace">
              <i class="tio-link"></i>
              @if (threadInfo?.linked_workspaces?.length > 0) {
                <span
                  *ngFor="
                    let workspace of threadInfo?.linked_workspaces;
                    let last = last;
                    let i = index
                  "
                >
                  {{ workspace.name
                  }}<span *ngIf="!last" style="font-weight: 400; opacity: 0.3">
                    |
                  </span>
                </span>
              } @else {
                Link to Workspace
              }
            </a>
          </span>
          <ul
            class="dropdown-menu"
            aria-labelledby="dLabel"
            *dropdownMenu
            style="width: 300px"
          >
            <li style="top: -9px; position: sticky; background: #fff">
              <div class="py-2 position-relative">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search workspaces"
                  [(ngModel)]="workspaceSearchText"
                />
                <i
                  [hidden]="!workspaceSearchText?.length"
                  class="tio-clear"
                  style="
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    opacity: 0.5;
                    font-size: 20px;
                  "
                  (click)="workspaceSearchText = ''"
                >
                </i>
              </div>
            </li>
            <li
              class="px-2"
              *ngFor="
                let workspace of dashboardStore.clients | activeClientsOnly
              "
              container="body"
            >
              <label
                class="py-1"
                style="width: 100%"
                [for]="workspace.uuid"
                (click)="checkIfCanUnlink(workspace)"
                *ngIf="
                  workspace.name
                    .toLowerCase()
                    .includes(workspaceSearchText?.toLowerCase())
                "
              >
                <p-checkbox
                  [value]="workspace.uuid"
                  [(ngModel)]="selectedWorkspaces"
                  (onChange)="addThreadToWorkspaceCheckBox($event, workspace)"
                  [inputId]="workspace.uuid"
                  class="pe-1"
                  [readonly]="isWorkspaceLinked(workspace.uuid)"
                  tooltipPosition="top"
                >
                </p-checkbox>
                <span class="ms-1">{{ workspace.name }}</span>
              </label>
            </li>
          </ul>
        </span>
      </div>

      <div class="email-top-actions">
        <button
          class="email-top-action ai"
          tooltip="Thread Summary"
          (click)="openSummarizeThreadDialog()"
        >
          <i class="tio-format_points"></i>
        </button>

        @if (threadInfo?.linked_workspaces?.length == 0) {
          <span
            dropdown
            placement="bottom right"
            [autoClose]="true"
            container="body"
            [insideClick]="true"
          >
            <div
              id="dLabel"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="dropdown-icon"
              dropdownToggle
            >
              <div
                style="position: relative; width: 30px; height: 24px"
                tooltip="Pin"
              >
                <div
                  style="
                    display: block;
                    position: absolute;
                    inset: 0;
                    z-index: 2;
                  "
                ></div>
                <ds-pin hovering="true" />
              </div>
            </div>
            <ul
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dLabel"
              *dropdownMenu
              style="width: 300px"
            >
              <li
                class="z-2"
                style="top: -9px; position: sticky; background: #fff"
              >
                <div class="py-2 position-relative">
                  <div class="mb-2" style="font-weight: 700" role="alert">
                    Choose the workspace to link this email to and create the
                    pin:
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search workspaces"
                    [(ngModel)]="workspaceSearchText"
                  />
                  <i
                    [hidden]="!workspaceSearchText?.length"
                    class="tio-clear"
                    style="
                      position: absolute;
                      right: 10px;
                      top: 50%;
                      transform: translateY(-50%);
                      cursor: pointer;
                      opacity: 0.5;
                      font-size: 20px;
                    "
                    (click)="workspaceSearchText = ''"
                  >
                  </i>
                </div>
              </li>
              <li
                class="px-2"
                *ngFor="
                  let workspace of dashboardStore.clients | activeClientsOnly
                "
              >
                <label
                  class="py-1"
                  style="width: 100%"
                  [for]="workspace.uuid"
                  *ngIf="
                    workspace.name
                      .toLowerCase()
                      .includes(workspaceSearchText?.toLowerCase())
                  "
                >
                  <p-checkbox
                    [value]="workspace.uuid"
                    [(ngModel)]="selectedWorkspaces"
                    (onChange)="
                      addThreadToWorkspaceCheckBox($event, workspace, true)
                    "
                    [inputId]="workspace.uuid"
                    class="pe-1"
                  ></p-checkbox>
                  <span class="ms-1">{{ workspace.name }}</span>
                </label>
              </li>
            </ul>
          </span>
        }

        @if (threadInfo?.linked_workspaces?.length == 1) {
          <ds-pin
            hovering="true"
            [type]="pinModel"
            [pin]="threadInfo?.linked_workspaces[0].pinned_item"
            [identifier]="thread?.id"
            [model]="thread"
            [company]="{ id: threadInfo?.linked_workspaces[0].id }"
            [availableStaff]="availableStaff"
            (pinActionCompleted)="onPinActionCompleted()"
          >
          </ds-pin>
        }

        @if (threadInfo?.linked_workspaces?.length == 0) {
          <button
            class="email-top-action create-job"
            [disabled]="jobCreationLoading"
            tooltip="Create Job"
            (click)="openCreateJobModal(createJobModal)"
          >
            @if (jobCreationLoading) {
              <p-progress-spinner
                class="icon-loading d-flex align-items-center"
                strokeWidth="5"
                fill="transparent"
                animationDuration=".5s"
                [style]="{ width: '16px', height: '16px', height: '22px' }"
              />
            } @else {
              <i class="tio-briefcase_outlined"></i>
            }
          </button>
        }

        @if (threadInfo?.linked_workspaces?.length == 1) {
          <div *ngFor="let workspace of threadInfo?.linked_workspaces">
            <button
              class="email-top-action create-job"
              [disabled]="jobCreationLoading"
              tooltip="{{
                workspace.job_uuid != null ? 'Open Job' : 'Create Job'
              }}"
              (click)="
                workspace.job_uuid != null
                  ? openJob(workspace.job_uuid)
                  : createJob(workspace)
              "
              *ngIf="!isFromDrawer"
            >
              @if (workspace.job_uuid != null) {
                <i class="tio-briefcase"></i>
              } @else {
                @if (jobCreationLoading) {
                  <p-progress-spinner
                    class="icon-loading d-flex align-items-center"
                    strokeWidth="5"
                    fill="transparent"
                    animationDuration=".5s"
                    [style]="{ width: '16px', height: '16px', height: '22px' }"
                  />
                } @else {
                  <i class="tio-briefcase_outlined"></i>
                }
              }
            </button>
          </div>
        }

        <button class="email-top-action mark-as-done" (click)="archiveThread()">
          <i class="tio-checkmark_circle_outlined"></i>
          Mark as Done
        </button>

        @if (
          threadInfo?.linked_workspaces?.length > 1 &&
          showWorkspacesActionsDropdown
        ) {
          <span
            dropdown
            placement="bottom right"
            [autoClose]="false"
            container="body"
            [insideClick]="true"
            #dropdownRef="bs-dropdown"
          >
            <span
              id="dLabel"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="dropdown-icon"
              dropdownToggle
            >
              <button class="email-top-action more">
                <i class="tio-more_horizontal"></i>
              </button>
            </span>
            <ul
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dLabel"
              *dropdownMenu
              style="width: 300px"
            >
              <li
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <h6
                  class="py-2 m-0"
                  style="font-weight: 600; font-size: 1.2rem"
                >
                  Actions on Each Workspace
                </h6>
                <div
                  (click)="closeDropdown(dropdownRef)"
                  style="cursor: pointer"
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="7.25464"
                      y="17.5962"
                      width="14.625"
                      height="1.625"
                      rx="0.8125"
                      transform="rotate(-45 7.25464 17.5962)"
                      fill="#485364"
                      style="
                        fill: #485364;
                        fill: color(display-p3 0.2824 0.3255 0.3922);
                        fill-opacity: 1;
                      "
                    />
                    <rect
                      width="14.625"
                      height="1.625"
                      rx="0.8125"
                      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 18.7451 17.5962)"
                      fill="#485364"
                      style="
                        fill: #485364;
                        fill: color(display-p3 0.2824 0.3255 0.3922);
                        fill-opacity: 1;
                      "
                    />
                  </svg>
                </div>
              </li>
              <li
                *ngFor="
                  let workspace of threadInfo?.linked_workspaces;
                  let last = last
                "
              >
                <div
                  class="d-flex align-items-center justify-content-between"
                  [ngClass]="{ 'mb-2': last }"
                >
                  <div class="text-uppercase">{{ workspace.name }}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ds-pin
                      hovering="true"
                      [type]="pinModel"
                      [pin]="workspace?.pinned_item"
                      [identifier]="thread?.id"
                      [model]="thread"
                      [company]="{ id: workspace.id }"
                      [availableStaff]="availableStaff"
                      (pinActionCompleted)="onPinActionCompleted()"
                    />

                    <button
                      class="email-top-action create-job"
                      tooltip="{{
                        workspace.job_uuid != null ? 'Open Job' : 'Create Job'
                      }}"
                      (click)="
                        workspace.job_uuid != null
                          ? openJob(workspace.job_uuid)
                          : createJob(workspace)
                      "
                      *ngIf="!isFromDrawer"
                      container="body"
                    >
                      @if (workspace.job_uuid != null) {
                        <i class="tio-briefcase"></i>
                      } @else {
                        <i class="tio-briefcase_outlined"></i>
                      }
                    </button>
                  </div>
                </div>
              </li>
              <li
                *ngFor="
                  let workspace of threadInfo?.linked_workspaces;
                  let last = last
                "
              >
                <div
                  class="d-flex align-items-center justify-content-between"
                  [ngClass]="{ 'mb-2': last }"
                >
                  <div class="text-uppercase">{{ workspace.name }}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ds-pin
                      hovering="true"
                      [type]="pinModel"
                      [pin]="workspace?.pinned_item"
                      [identifier]="thread?.id"
                      [model]="thread"
                      [company]="{ id: workspace.id }"
                      [availableStaff]="availableStaff"
                      (pinActionCompleted)="onPinActionCompleted()"
                    />

                    <button
                      class="email-top-action create-job"
                      tooltip="{{
                        workspace.job_uuid != null ? 'Open Job' : 'Create Job'
                      }}"
                      (click)="
                        workspace.job_uuid != null
                          ? openJob(workspace.job_uuid)
                          : createJob(workspace)
                      "
                      *ngIf="!isFromDrawer"
                      container="body"
                    >
                      @if (workspace.job_uuid != null) {
                        <i class="tio-briefcase"></i>
                      } @else {
                        <i class="tio-briefcase_outlined"></i>
                      }
                    </button>
                  </div>
                </div>
                <hr
                  class="my-3 opacity-100 border"
                  style="border-color: black"
                  *ngIf="!last"
                />
              </li>
            </ul>
          </span>
        }
      </div>

      <!-- Summarized thread dialog -->
      <p-dialog
        header="Thread Summary"
        class="thread-summary-dialog"
        [ngClass]="{ animated: cursorVisible || summarizeLoading }"
        [modal]="false"
        [(visible)]="visible"
        [position]="position"
        [style]="{ width: '33vw' }"
      >
        <div *ngIf="summarizeLoading || loading" class="text-center p-4">
          <p-skeleton styleClass="mb-2" />
          <p-skeleton width="10rem" styleClass="mb-2" />
          <p-skeleton width="5rem" styleClass="mb-2" />
        </div>
        <div *ngIf="!summarizeLoading" class="thread-summary">
          <markdown [data]="summaryText"> </markdown
          ><span *ngIf="cursorVisible" class="cursor"></span>
        </div>
      </p-dialog>
    </div>
  </div>
  <div *ngIf="thread != null" class="inbox-email-view-scrollbars">
    <div class="inbox-email-view">
      <div
        class="inbox-email-messages past"
        (click)="collapsed = true"
        [ngClass]="collapsed ? '' : 'collapsed'"
      >
        <div
          class="inbox-email-messages-item"
          [ngClass]="{ current: message.uuid === selectedMessage?.uuid }"
          *ngFor="let message of thread.messages"
        >
          <div class="header email-header">
            <div class="avatar-wrapper">
              <div class="avatar" tooltip="{{ message.from_email['name'] }}">
                <div
                  class="initials"
                  initials
                  [name]="message.from_email['name']"
                ></div>
              </div>
            </div>
            <div class="email-info-wrapper">
              <div class="person-info">
                <div class="name" tooltip="{{ message.from_email['address'] }}">
                  {{ message.from_email["name"] }}
                </div>
                <div class="email">
                  <div class="to">
                    To:
                    <span *ngFor="let message of message.to; let last = last">
                      {{ message["address"] }}<span *ngIf="!last">, </span>
                    </span>
                  </div>
                  @if (message.cc?.length > 0) {
                    <div class="cc">
                      Cc:
                      <span *ngFor="let message of message.cc; let last = last">
                        {{ message["address"] }}<span *ngIf="!last">, </span>
                      </span>
                    </div>
                  }
                  @if (message.bcc?.length > 0) {
                    <div class="bcc">
                      Bcc:
                      <span
                        *ngFor="let message of message.bcc; let last = last"
                      >
                        {{ message["address"] }}<span *ngIf="!last">, </span>
                      </span>
                    </div>
                  }
                </div>
              </div>
              <div class="email-info">
                <div class="date" title="December 27, 2023 - 10:15 AM">
                  {{ message.date | amTimeAgo }}
                </div>
              </div>
            </div>
          </div>
          <div class="email-body" [innerHTML]="message?.html | keepHtml"></div>
          <div class="email-snippet">{{ message.snippet }}</div>

          <div class="attachments" *ngIf="message.attachments_list?.length > 0">
            <hr />
            <h4>Attachments</h4>
            <div class="attachments-wrapper">
              <div
                class="attachment"
                *ngFor="let attachment of message.attachments_list"
                (click)="openAttachment(attachment, message)"
              >
                <div
                  class="attachment-extension file-icon file-{{
                    getFileExt(attachment.filename)
                  }}"
                  [style.background-image]="
                    'url(' + attachment.secure_url + ')'
                  "
                >
                  <span
                    *ngIf="
                      ![
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'bmp',
                        'svg',
                        'webp',
                      ].includes(getFileExt(attachment.filename).toLowerCase())
                    "
                  >
                    {{ getFileExt(attachment.filename) }}
                  </span>
                </div>
                <!-- I want to limit the filename size to 15 characters then the file extension -->
                <div
                  class="attachment-name mt-3"
                  [title]="
                    attachment.filename.length > 16 ? attachment.filename : ''
                  "
                >
                  {{
                    attachment.filename.length > 16
                      ? attachment.filename.substring(0, 16) +
                        "..." +
                        getFileExt(attachment.filename)
                      : attachment.filename
                  }}
                </div>

                <!-- Prevent default on click -->
                <a
                  (click)="$event.stopPropagation()"
                  [href]="attachment.secure_url"
                  download
                  class="btn btn-default mt-3"
                >
                  <i class="tio-download_to"></i> Download
                </a>

                <!-- <div class="attachment-size">200 kb</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <email-form
    [composeMode]="composeMode"
    [thread]="thread"
    (moveToTrash)="moveToTrash()"
  ></email-form>
  <div *ngIf="thread == null" class="email-empty-space">
    <div class="text-center">
      <svg
        width="66"
        height="58"
        viewBox="0 0 66 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M44.3412 40.9371L28.3902 26.0269C28.0753 25.7336 27.6161 25.6543 27.2211 25.8251C26.8261 25.9967 26.571 26.3859 26.571 26.8169V48.4404C26.571 48.8563 26.8096 49.2354 27.1844 49.4149C27.5585 49.5958 28.0039 49.5447 28.3283 49.2845L32.7337 45.7584L36.8976 55.3491C37.1355 55.8969 37.7727 56.1485 38.3198 55.9099L41.6253 54.4741C42.1731 54.2362 42.4239 53.5998 42.186 53.052L39.992 47.9986L38.0221 43.462L43.7264 42.8024C44.1451 42.7542 44.4976 42.4666 44.6295 42.0665C44.7614 41.665 44.649 41.2254 44.3412 40.9371Z"
          fill="#151C29"
        />
        <path
          d="M19.1109 30.6468L8.94971 34.6233"
          stroke="#959DAB"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M47.6245 19.4881L37.4633 23.4647"
          stroke="#959DAB"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M21.4349 9.56509L25.4114 19.7263"
          stroke="#959DAB"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M10.8109 18.8923L20.3718 24.1507"
          stroke="#959DAB"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M35.2312 9.09481L31.9558 19.5032"
          stroke="#959DAB"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <h4 class="mt-4">Select an email</h4>
      <p style="font-size: 14px">Click an email from the list at the left.</p>
    </div>
  </div>
</div>

<ng-template #selectWorkspaceModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Select Workspace</h4>
  </div>
  <div class="modal-body text-center">
    <i class="feather clipboard x3" style="color: #0075ff"></i>
    <h4>Choose the workspace where this email should be added:</h4>
    <input
      [(ngModel)]="duplicateSelected"
      (typeaheadOnSelect)="selectClient($event)"
      [typeahead]="dashboardStore.clients | activeClientsOnly"
      typeaheadOptionField="name"
      [typeaheadOptionsLimit]="9999"
      [typeaheadMinLength]="0"
      placeholder="Choose a workspace"
      class="form-control"
    />
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
    <button
      class="btn btn-primary pull-right"
      [disabled]="duplicateSelected == null || duplicateSelected == ''"
      (click)="linkThreadToWorkspace()"
    >
      Link Workspace
    </button>
  </div>
</ng-template>

<ng-template #createJobModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Create new job</h4>
  </div>
  <div class="modal-body text-center">
    <i class="feather clipboard x3" style="color: #0075ff"></i>
    <h4>Choose the workspace where this Job should be added:</h4>
    <input
      [(ngModel)]="duplicateSelected"
      (typeaheadOnSelect)="selectClient($event)"
      [typeahead]="dashboardStore.clients | activeClientsOnly"
      typeaheadOptionField="name"
      [typeaheadOptionsLimit]="9999"
      [typeaheadMinLength]="0"
      placeholder="Choose a workspace"
      class="form-control"
    />
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
    <button
      class="btn btn-primary pull-right"
      [disabled]="duplicateSelected == null || duplicateSelected == ''"
      (click)="createJob()"
    >
      Create Job
    </button>
  </div>
</ng-template>

<ng-template #createPinModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Pin Email</h4>
  </div>
  <div class="modal-body text-center">
    <i class="tio-pin x3" style="color: #0075ff"></i>
    <h4>Choose the workspace where this item should be pinned:</h4>
    <input
      [(ngModel)]="duplicateSelected"
      (typeaheadOnSelect)="selectClient($event)"
      [typeahead]="dashboardStore.clients | activeClientsOnly"
      typeaheadOptionField="name"
      [typeaheadOptionsLimit]="9999"
      [typeaheadMinLength]="0"
      placeholder="Choose a workspace"
      class="form-control"
    />
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
    <button
      class="btn btn-primary pull-right"
      [disabled]="duplicateSelected == null || duplicateSelected == ''"
      (click)="pinEmail()"
    >
      Pin Item
    </button>
  </div>
</ng-template>
